import {Injectable} from '@angular/core';
import {PostPayloadInterface} from '../utilities/post-payload.interface';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseRepository, PositoryErrorHandlerService, Path, RepoPath} from 'ng-pository';
import {ValidatorService} from '../services/validator.service';
import {Addon} from '../models/addon.model';
import {FilterPayloadInterface} from "../services/filterer/filter-payload-interface";
import {Webhook} from "../models/webhook.model";

@RepoPath('/mgmt')
@Injectable({
  providedIn: 'root'
})
export class WebhookRepository extends BaseRepository<PostPayloadInterface> {
  constructor(httpClient: HttpClient, errorhandler: PositoryErrorHandlerService) {
    super(httpClient, errorhandler);
  }

  @Path('/partner/webhook/filter')
  getAllByFilter(filter: FilterPayloadInterface) {
    const options = {params: new HttpParams().append('filter', JSON.stringify(filter))};
    return super.get(undefined, options);
  }

  @Path('/partner/webhook/{id}')
  getById(id: string) {
    return super.get();
  }

  @Path('/partner/webhook')
  save(webhook: Webhook) {
    return super.post({
      type: 'Add',
      id: 0,
      attribute: webhook
    });
  }

  @Path('/partner/webhook/{id}')
  update(id: number, webhook: Webhook) {
    return super.put({
      type: 'Update',
      id: 0,
      attribute: webhook
    });
  }

  @Path('/partner/webhook/{id}')
  deleteById(id: string) {
    return super.delete();
  }

  validate(editableRow: Addon) {
    ValidatorService.allRequired(editableRow, Object.keys(editableRow), 'Addon');
  }

}

